import { Component, OnInit, ViewChild } from '@angular/core';

import { UtilityService } from 'app/core/core.module';
import { DxDataGridComponent } from 'devextreme-angular';
import _ from 'lodash';
import moment from 'moment';

@Component({
    selector: 'app-event-calendar',
    templateUrl: './event-calendar.component.html',
    styleUrls: ['./event-calendar.component.scss'],
    imports: [],
    standalone: true,
})
export class EventCalendarComponent implements OnInit {
    events: any[] = [];
    sunday: any;
    saturday: any;
    nextSunday: any;
    nextSaturday: any;
    weekData = [];
    week1: any = [];
    week2: any = [];

    constructor(private utility: UtilityService) {}

    async ngOnInit() {
        const today = new Date();
        this.sunday = moment(today).isoWeekday(0).format('MMMM DD');
        this.saturday = moment(today).isoWeekday(6).format('MMMM DD');
        this.nextSunday = moment(today).isoWeekday(7).format('MMMM DD');
        this.nextSaturday = moment(today).isoWeekday(13).format('MMMM DD');
        await this.getData();
    }

    async getData() {
        let start = moment().isoWeekday(0).toDate();
        let end = moment().isoWeekday(13).toDate();
        await this.getWeekData(start, end, 0);
    }

    async getWeekData(start: Date, end: Date, weekOffset: number): Promise<any> {
        // console.log('start', start);
        // console.log('end', end);
        const events = (await this.utility.getCalendarInfos(start, end)) as any[];
        // console.log('events', events);

        const eventsByDate = [];
        for (let index = 0; index < 14; index++) {
            const date = moment().isoWeekday(index).toDate();
            const eventMatch: any = events.filter((x) => {
                if (moment(date).format('MM/DD/YYYY') === x.EventDateStr) return x;
            });

            const eventDetails = [];
            if (eventMatch.length > 0) {
                _.orderBy(eventMatch[0].Details,['StartHour','StartMin']).forEach((detail) => {
                    detail.start = moment(detail.StartTime).format('h:mm a');
                    detail.end = moment(detail.EndTime).format('h:mm a');
                    eventDetails.push(detail);
                });
            }

            // console.log('date', date);
            // console.log('eventDetails', eventDetails);

            if (index < 7)
                this.week1.push({
                    date: moment(date).format('dddd MMMM DD, yyyy'),
                    eventDetails: eventDetails,
                });
            else
                this.week2.push({
                    date: moment(date).format('dddd MMMM DD, yyyy'),
                    eventDetails: eventDetails,
                });
        }

        this.events.push({
            week: 1,
            sunday: moment().isoWeekday(0).format('MMMM DD'),
            saturday: moment().isoWeekday(6).format('MMMM DD'),
            weekData: this.week1,
        });
        this.events.push({
            week: 2,
            sunday: moment().isoWeekday(7).format('MMMM DD'),
            saturday: moment().isoWeekday(13).format('MMMM DD'),
            weekData: this.week2,
        });

        // console.log('eventsByDate', eventsByDate);
        // console.log('eventsByDate', this.events);

        //     // const element = events[index];
        //     if (!element) {
        //         // console.log('push');
        //         missingDays.push({
        //             EventDate: moment().add(weekOffset,'weeks').isoWeekday(index).toDate(),
        //             Details: null,
        //         });
        //     }
        // }
        // missingDays.forEach((missingDay) => {
        //     events.push(missingDay);
        // });
        // // console.log(missingDays);
        // // console.log(events);

        // events.forEach((event, index) => {
        //     event.date = moment(event.EventDate).format('dddd MMMM DD, yyyy');
        //     if (!!event.Details && event.Details.length > 0) {
        //         event.Details.forEach((detail) => {
        //             detail.start = moment(detail.StartTime).format('h:mm a');
        //             detail.end = moment(detail.EndTime).format('h:mm a');
        //         });
        //     }
        // });
        return eventsByDate;
    }
}
